export const VSP_OPEN_EVENT = 'ents:vsp:open';
export const SUCH_VSP_OPEN_EVENT = 'suchen:vsp:alternativeprodukte';

export interface VspOpenEventDetail {
  syan: number;
  colorId?: string;
}

export interface SuchVspPayload {
  syan: number;
  farbId?: string;
  listName: string;
}

export interface VspDispatchParams {
  syan: number;
  colorId?: string;
  listName: string;
}

export function dispatchVspOpen(recoVspEnabled: boolean, params: VspDispatchParams): SuchVspPayload {
  const { syan, colorId, listName } = params;
  const suchPayload: SuchVspPayload = {
    syan,
    ...(colorId ? { farbId: colorId } : {}),
    listName,
  };
  if (recoVspEnabled) {
    const detail: VspOpenEventDetail = { syan, ...(colorId ? { colorId } : {}) };
    document.dispatchEvent(new CustomEvent<VspOpenEventDetail>(VSP_OPEN_EVENT, { detail }));
  } else {
    document.dispatchEvent(new CustomEvent<SuchVspPayload>(SUCH_VSP_OPEN_EVENT, { detail: suchPayload }));
  }
  return suchPayload;
}
